/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_auth_sign_in_btn = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in`)
};

const es_auth_sign_in_btn = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciar sesión`)
};

const de_auth_sign_in_btn = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anmelden`)
};

const nl_auth_sign_in_btn = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inloggen`)
};

const fr_auth_sign_in_btn = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se connecter`)
};

const it_auth_sign_in_btn = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accedi`)
};

const pt_br2_auth_sign_in_btn = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrar`)
};

const pt_auth_sign_in_btn = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciar sessão`)
};

const ja_auth_sign_in_btn = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ログイン`)
};

const zh_auth_sign_in_btn = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登录`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const auth_sign_in_btn = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.auth_sign_in_btn(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("auth_sign_in_btn", locale)
	if (locale === "en") return en_auth_sign_in_btn(inputs)
	if (locale === "es") return es_auth_sign_in_btn(inputs)
	if (locale === "de") return de_auth_sign_in_btn(inputs)
	if (locale === "nl") return nl_auth_sign_in_btn(inputs)
	if (locale === "fr") return fr_auth_sign_in_btn(inputs)
	if (locale === "it") return it_auth_sign_in_btn(inputs)
	if (locale === "pt-BR") return pt_br2_auth_sign_in_btn(inputs)
	if (locale === "pt") return pt_auth_sign_in_btn(inputs)
	if (locale === "ja") return ja_auth_sign_in_btn(inputs)
	return zh_auth_sign_in_btn(inputs)
};